import { useEffect, useState } from 'react';
import { colorArriba, colorArribaGuardado } from '../utils/colorArriba';

const url = (u) => (!u ? null : u.startsWith('http') ? u : `https://${u}`);

// Imagen cuyo color de arriba debe llevar el header sin imagen propia: el
// fondo de la sección promocional (si está encendida y tiene fondo).
export const imagenBajoHeader = (restaurant) => {
  const promo = restaurant?.promoSection;
  return !restaurant?.headerBackground && promo?.isActive ? url(promo.background) : null;
};

/**
 * Color liso del header cuando no tiene imagen: el de arriba del fondo de la
 * sección promocional, para que se fundan. null = usar el token
 * (bg-header-bg), que ya es el verde de la sección cuando no hay imagen.
 */
export function useColorHeader(restaurant) {
  const imagen = imagenBajoHeader(restaurant);
  const [color, setColor] = useState(() => colorArribaGuardado(imagen));

  useEffect(() => {
    let vivo = true;
    setColor(colorArribaGuardado(imagen));
    colorArriba(imagen).then((c) => { if (vivo) setColor(c); });
    return () => { vivo = false; };
  }, [imagen]);

  return imagen ? color : null;
}
